<!-- Pesquisa.svelte -->
<script>
    import { createEventDispatcher, onMount } from 'svelte';
  
    let timer;
    let value = '';
    let loading=false;
   
    export let parametros;
    export let extraiDadosBasico=null;

    const dispatch = createEventDispatcher();
  
    function handleInput(event) {
      // Cancela o timer anterior se houver um
      loading=true;
      clearTimeout(timer);
      
      // Atualiza o valor da pesquisa
      value = event.target.value;
  
      // Configura um novo timer para despachar a pesquisa após 2 segundos
      timer = setTimeout(() => {
        dispatch('pesquisar', { valor: value }
      
        );
        Pesquisar(value);
          loading=false;
      }, 2000);
    }

 async function Pesquisar(event) {
   
    parametros.termo_pesquisa = event; // Atualiza o termo de pesquisa nos parâmetros
    await conectar(true); // Chama o método conectar do componente ExtraiDadosBasico
  }
   async function conectar(apaga) {
    if(extraiDadosBasico!=null){
        extraiDadosBasico.conectar(apaga); // Chama o método conectar do componente ExtraiDadosBasico
  
    }
  }
   //onMount(conectar()) ;
  </script>
  
  <style>
    .largura {
      width: 100%;
     
      border: 1px solid #ccc;
      border-radius: 4px;
      padding:5px;
      
     
    }
    input{
      margin-left: 2px;
    }
    .search-icon {
      padding-inline: 5px;
      right: 0.5rem;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
    }

    .loading {
   
    height: 50px; /* Altura do ícone de carregamento */
  }

  .fa-spinner {
    animation: spin 1s infinite linear; /* Animação de rotação */
     display: flex;
    justify-content: center;
    align-items: center;
     padding-inline: 5px;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  </style>
<div class="d-flex align-items-center w-100 largura">
  <input class="flex-grow-1" type="text" placeholder="Pesquisar..." on:input={handleInput} />
  {#if !loading}
  <i class="fas fa-search fa-lg search-icon"></i>
  {:else}
  
  <i class="fas fa-spinner fa-spin"></i>

   
  {/if}
</div>


<slot/>
  

  
  

  